import React from 'react';
import { Form, Icon, Input, Radio, Select } from 'antd';
import Signature from "./Signature";

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    const showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);
    const isEmail = props.consentMethodType === 'EmailRegainedCapacity'

    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUS</h4>

          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.has_randomization_platform_step_3_patient_regained_capacity ? <div
            dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_patient_regained_capacity_content}}/> :
          <div style={{textAlign: 'justify'}}>
            <p>Je certifie qu’on a expliqué au/à la participant(e) le présent formulaire d’information et de consentement, que l’on a répondu aux questions que le sujet de recherche avait.</p>
            <p>Je m’engage, avec l’équipe de recherche, à respecter ce qui a été convenu au formulaire d’information et de consentement et à en remettre une copie signée et datée au/à la participant(e).</p>
            <p>Version 2.1(2020-12-10)</p>
          </div>}
        <p><strong>Server Date (UTC): {props.consentDate || props.date}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <div style={{ textAlign: 'left' }}>
        {isEmail &&
          <div>
            <h4>Email</h4>
          <Form.Item>
            {props.form.getFieldDecorator('mtl_consent_participant_email', {
              initialValue: props.mtl_consent_participant_email,
              rules: [{required: true, message: 'Veuillez saisir l\'email du participant'}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="Email du participant"/>
            )}
          </Form.Item>
          </div>}
            <h4>SIGNATURE DU PARTICIPANT REDEVENU APTE</h4>
            <p>J’ai examiné l’ensemble du formulaire d’information et de consentement et je comprends que mon représentant légalement autorisé a accepté, en mon nom, que je participe à ce projet de recherche. Je reconnais que ce projet de recherche m’a été expliqué, qu’on a répondu à mes questions à ma satisfaction et que j’ai eu assez de temps pour prendre une décision.</p>
            <p>Je consens à continuer à participer à ce projet de recherche conformément aux conditions énoncées ci- dessus. Je recevrai une copie signée et datée de ce formulaire d’information et de consentement.</p>
            <p>J’autorise l’équipe de l’étude de recherche à accéder à mon dossier médical pour les besoins de cette étude.</p>

          {showForEmail && <div>
            <Form.Item>
              <label>
                <div className='form-label'>Veuillez cocher la case appropriée pour indiquer votre décision:</div>
                {props.form.getFieldDecorator('mtl_rccf_consent_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='stay_in_study'>
                      Je désire demeurer dans l’étude.
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      Je désire me retirer de l’étude.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
          </div>}

          <Form.Item>
            <label>
              <div className='form-label'>Nom du participant (patient):</div>
              {props.form.getFieldDecorator('mtl_rccf_consent_participant_name', {
                initialValue: props.mtl_rccf_consent_participant_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Nom du participant (patient)"
                />
              )}
            </label>
          </Form.Item>

              {showForEmail && <Signature fieldName='mtl_rccf_consent_participant_signature' label='Signature' form={props.form} /> }

          {!isEmail && <Form.Item>
            <label>
              <div className='form-label'>Nom du témoin/lien avec le participant:</div>
              {props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', {
                initialValue: props.mtl_rccf_consent_witness_name_and_relationship,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Nom du témoin/lien avec le participant"
                />
              )}
            </label>
          </Form.Item>}

          {!isEmail && <Signature fieldName='mtl_rccf_consent_witness_signature' label='Signature' form={props.form} />}

          {!isEmail && <p>Un témoin appose sa signature (i) en plus du patient si le consentement éclairé est lu au patient, ou (ii) à la place du patient pour les patients qui sont légalement aptes à donner leur consentement, mais qui sont incapables de lire ou d’écrire (p. ex., la signature du témoin est apposée à côté de l’empreinte du pouce du patient).</p>}


          <p><b>Signature de la personne obtenant le consentement</b></p>
          <p>J’ai expliqué au participant à la recherche l’étude de recherche et les termes du présent formulaire d’information et de consentement et j’ai répondu à toutes ses questions.</p>
          <Form.Item>
            <label>
              <div className='form-label'>Nom (en lettres moulées):</div>
              {props.form.getFieldDecorator('mtl_rccf_consent_investigator_name', {
                initialValue: props.mtl_rccf_consent_investigator_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  disabled={props.token}
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Nom (en lettres moulées)"
                />
              )}
            </label>
          </Form.Item>

          {!props.token && <Signature fieldName='mtl_rccf_consent_investigator_signature' label='Signature de la personne qui obtient le consentement' form={props.form} />}

          <h4>ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUS</h4>
          <p>Je certifie qu’on a expliqué au/à la participant(e) le présent formulaire d’information et de consentement, que l’on a répondu aux questions que le sujet de recherche avait.</p>
          <p>Je m’engage, avec l’équipe de recherche, à respecter ce qui a été convenu au formulaire d’information et de consentement et à en remettre une copie signée et datée au/à la participant(e).</p>

          <hr />
          <br/>

          {/* {showForEmail && <div>
            <p>Please check the appropriate box to indicate your decision:</p>
            <Form.Item>
              <label>
                <div className='form-label'>Please check the appropriate box to indicate your decision:</div>
                {props.form.getFieldDecorator('rccf_consent_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='stay_in_study'>
                      I wish to stay in the study.
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      I wish to withdraw from the study
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study_allow_data_collection_via_linkage'>
                      I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

          </div>}

          <Form.Item>
            <label>
              <div className='form-label'>Participant Name</div>
              {props.form.getFieldDecorator('rccf_participant_name', {
                initialValue: props.rccf_participant_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Participant Name"
                />
              )}
            </label>
          </Form.Item>

          {props.consentMethodType === 'EmailRegainedCapacity' && <Form.Item>
            {props.form.getFieldDecorator('sb_dic_participant_email', {
              initialValue: props.sb_dic_participant_email,
              rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="Participant Email"/>
            )}
          </Form.Item>}

          {props.consentPersonType === 'Patient' && showForEmail  && (
            <div>
              <Signature fieldName='rccf_participant_signature' label='Signature of Participant' form={props.form} />
            </div>
          )}


          {!props.token && <div>
            <h4>Person Obtaining Consent</h4>
            <ul>
              <li>By signing this form, I confirm that:</li>
              <li>This study and its purpose has been explained to the participant named above</li>
              <li>All questions asked by the participant have been answered</li>
              <li>I will give a copy of this signed and dated document to the participant</li>
            </ul>
          </div>}

          <div>
            <Form.Item>
              <label>
                <div className='form-label'>Name of Person Obtaining Consent</div>
                {props.form.getFieldDecorator('rccf_investigator_name', {
                  initialValue: props.rccf_investigator_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Name of Person Obtaining Consent"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && <Signature fieldName='rccf_investigator_signature' label='Signature of Person Obtaining Consent' form={props.form} />}
          </div> */}

          {showForEmail && <Form.Item>
            <label>
              <div className='form-label'>Do you consent to the terms described above?</div>
              {props.form.getFieldDecorator('consent_provided', {
                initialValue: props.consent_provided,
                rules: [{
                  required: true,
                  message: 'Do you consent to the terms described above?'
                }],
              })(
                <Select>
                  <Option value="yes">Yes</Option>
                  <Option value="">No</Option>
                </Select>
              )}
            </label>
          </Form.Item>}
          <hr />
          <br/>

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeChus/Step3aRegainedCapacity.js